import React from "react";

import RangeList from "./rangeSlider/range-list";

import { Input, Textarea, Checkbox, Select, NumberField, Measurement, MeasurementList } from "../../../../form-inputs/inputs";
import { PACKAGE_SIZES, BULB_TYPES, BULB_COLORS, INDOOR_OUTDOOR, BULB_BASES } from "../lib/constants";
import { DEFAULT_RANGE } from "./rangeSlider/lib/constant";
import { EMPTY_DOLLAR } from "../../../../../shared/typeahead-prefill";

const LightingForm = (props) => {
    const FTCLink = (
        <span>
            <span>FTC Mercury Warning (</span>
            <a href="https://www.epa.gov/cfl" rel="noopener noreferrer" target="_blank">
                epa.gov/cfl
            </a>
            )
        </span>
    );
    const panel = props.panel;

    return (
        <div>
            <div className="panel">
                <Input label="Model Number" name="modelNumber" value={panel.modelNumber} updateOnChange={props.updateField} />
                <MeasurementList label="Brightness Quality" name="brightness" value={panel.brightness} updateOnChange={props.updateField} />
                <MeasurementList label="Estimated Yearly Cost" name="estimatedYearlyCost" value={panel.estimatedYearlyCost} updateOnChange={props.updateField} prefill={EMPTY_DOLLAR} />
                <Input label="Estimated Energy Cost Disclaimer" name="estimatedYearlyCostDisclaimer" value={panel.estimatedYearlyCostDisclaimer} updateOnChange={props.updateField} />

                <Measurement label="Bulb Life" name="lifeExpectancy" defaultValue={panel.lifeExpectancy} updateOnChange={props.updateField} />
                <Input label="Bulb Life Disclaimer" name="lifeExpectancyDisclaimer" value={panel.lifeExpectancyDisclaimer} updateOnChange={props.updateField} />

                <RangeList name="ranges" ranges={panel.ranges} updateState={props.updateField} defaultValue={DEFAULT_RANGE} />

                <MeasurementList label="Energy Used" name="energyUsed" value={panel.energyUsed} updateOnChange={props.updateField} />
                <Measurement label="Voltage" name="voltage" defaultValue={panel.voltage} updateOnChange={props.updateField} />

                <Select label="Package Size" name="packageSize" options={PACKAGE_SIZES} value={panel.packageSize} updateOnChange={props.updateField} />
                <NumberField label="Total Bulbs in Package" name="bulbQuantity" value={panel.bulbQuantity} updateOnChange={props.updateField} />
                <Select label="Bulb Type" name="bulbType" options={BULB_TYPES} value={panel.bulbType} updateOnChange={props.updateField} />
                <Select label="Bulb Color" name="bulbColor" options={BULB_COLORS} value={panel.bulbColor} updateOnChange={props.updateField} />
                <Select label="Indoor or Outdoor Bulb" name="indoorOutdoor" options={INDOOR_OUTDOOR} value={panel.indoorOutdoor} updateOnChange={props.updateField} />

                <Checkbox label="3 Way Light Bulb" name="isThreeWay" value={panel.isThreeWay} updateOnChange={props.updateField} />
                <Checkbox label="Dimmable" name="isDimmable" value={panel.isDimmable} updateOnChange={props.updateField} />
                <Checkbox label="Flood Light" name="isFloodLight" value={panel.isFloodLight} updateOnChange={props.updateField} />
                <Checkbox label="Ceiling Fan Compatible" name="isCeilingFanCompatible" value={panel.isCeilingFanCompatible} updateOnChange={props.updateField} />
                <Checkbox label="Eco Friendly" name="isEcoFriendly" value={panel.isEcoFriendly} updateOnChange={props.updateField} />
                <Checkbox label="Energy Star" name="hasEnergyStarLogo" value={panel.hasEnergyStarLogo} updateOnChange={props.updateField} />
                <Checkbox label="Energy Smart" name="hasEnergySmartLogo" value={panel.hasEnergySmartLogo} updateOnChange={props.updateField} />
                <Checkbox label="Contains Mercury" name="containsMercury" value={panel.containsMercury} updateOnChange={props.updateField} />

                {panel.containsMercury && (
                    <div>
                        <Textarea label={FTCLink} name="FTCMercuryWarning" value={panel.FTCMercuryWarning} updateOnChange={props.updateField} />
                    </div>
                )}

                <Select label="Base Type" name="baseType" options={BULB_BASES} value={panel.baseType} updateOnChange={props.updateField} />
                <Input label="Base Size" name="baseSize" value={panel.baseSize} updateOnChange={props.updateField} />

                <Textarea label="Legal Terms" name="legalTerms" value={panel.legalTerms} updateOnChange={props.updateField} />
                <Textarea label="Additional Product Details" name="additionalProductDetails" value={panel.additionalProductDetails} updateOnChange={props.updateField} />
                <Textarea label="Additional Warnings" name="additionalWarnings" value={panel.additionalWarnings} updateOnChange={props.updateField} />
            </div>
        </div>
    );
};

export default LightingForm;
